import React from "react";
import * as Styled from "./styles";
import {
  Button,
  MenuItem,
  Select,
  FormControl,
  InputLabel,
  CircularProgress,
  Typography,
  Divider,
  TextField,
} from "@mui/material";
import {
  LocalizationProvider,
  DatePicker,
  PickersDayProps,
  PickersDay,
} from "@mui/x-date-pickers";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { useFirstConsult } from "shared/providers/FirstConsult";
import "dayjs/locale/pt-br";
import { getTimeTable } from "requests/Time";
import { useAuth } from "shared/providers/auth";
import dayjs, { Dayjs } from "dayjs";
import toast from "react-hot-toast";

// Define a interface para as horas disponíveis
interface AvailableDates {
  [date: string]: string[];
}

// Define a interface para o objeto de resposta da API
interface ApiResponse {
  bestDay: string;
  availableDates: AvailableDates;
  separetor: { idDent: number };
}

// Define a interface para o objeto transformado
interface TransformedDate {
  date: string;
  hours: string[];
}

const Schedule: React.FC = () => {
  const {
    setStep,
    selectedDate,
    selectedTime,
    selectedHour,
    handleDateChange,
    handleTimeChange,
    handleHourChange,
    bestTime,
    setBestTime,
    //setSelectedHour,
    mostImportantType,
    setMostImportantType,
    setBandaExists,
    setBandaId,
    bandaExists,
    selectedDateBand,
    selectedHourBand,
    selectedTimeBand,
    handleDateChangeBand,
    handleTimeChangeBand,
    handleHourChangeBand,
    setSelectedProceduresId,
    setSeparatorId,
    aparate,
    aparateBrace,
    glue,
    glueTube,
    wire,
    changeWire,
    ciment,
    cimentBand,
    keep,
    keepThread,
    valueOthers,
    patientObj,
    /*needsBand,
    glueProcedures,
    glueTubProcedures,
    wireProcedures,
    changeWireProcedures,
    keepThreadProcedures,
    keepProcedures,
    cimentProcedures,
    cimentBandProcedures,*/
    complement,
    braceMovel,
    infMovable,
    supMovable,
    relizeMoldage,
    installMovable,
    moldageSecondMovable,
    infMovableProcedure,
    supMovableProcedure,
    hoursTime,
    setHoursTime,

    bestTimeBand,
    setBestTimeBand,

    selectedProceduresId,
    controlContainment,
    highPlanning,
  } = useFirstConsult();
  const { user } = useAuth();

  const [loading, setLoading] = React.useState<boolean>(false);
  const [hoursTimeBandState, setHoursTimeBandState] = React.useState<string[]>([]);
  const [apiResponse, setApiResponse] = React.useState<ApiResponse>(
    {} as ApiResponse
  );

  const [apiResponseBand, setApiResponseBand] = React.useState<ApiResponse>(
    {} as ApiResponse
  );

  const orderByImportance = React.useCallback(() => {
    const importanceOrder: number[] = [
      55, 56, 2, 285, 30, 31, 7, 201, 290, 294, 295, 136, 127, 178, 492, 144,
      146, 493, 491, 65, 490, 134, 138, 440, 266,
    ];

    const typeMap: Record<number, string> = {
      55: "Colagem Inferior",
      56: "Colagem Superior",
      2: "1º Consulta",
      285: "Colagem de Tubo",
      30: "Banda Inferior",
      31: "Banda Superior",
      7: "Alta",
      201: "Remoção de Aparelho",
      290: "Instalação de Contenção Superior e Inferior",
      294: "Instalação de Contenção Superior",
      295: "Instalação de Contenção Inferior",
      136: "Manutenção",
      127: "Instalação Aparelho Móvel Inferior",
      128: "Instalação Aparelho Móvel Superior",
      492: "Instalacao de aparelho movel",
      144: "Moldagem Inferior",
      146: "Moldagem Superior",
      493: "Moldagem do Aparelho",
      491: "Manutenção",
      65: "Controle de Contenção",
      490: "Manutenção",
      134: "Manutenção",
      138: "Manutenção",
      440: "Manutenção",
      266: "Manutenção",
    };

    const initialValues: number[] = [];
    let newValues: number[] = [...initialValues];

    /*if (patientObj.type === 2) {
      if (needsBand === "YES") {
        newValues = [...newValues, 31];
      }
    }*/

    if (patientObj.type === 3) {
      newValues = [...newValues, 136];
    }

    if (controlContainment) {
      newValues = [...newValues, 65];
    }

    if (highPlanning) {
      newValues = [...newValues, 7];
    }

    if (aparate) {
      if (aparateBrace.includes("SUP")) {
        newValues = [...newValues, 2, 56];
      } else if (aparateBrace.includes("INF")) {
        newValues = [...newValues, 2, 55];
      }
    }

    if (glue) {
      if (glueTube.includes("INF") || glueTube.includes("SUP")) {
        newValues = [...newValues, 285];
      }
    }

    if (wire) {
      if (changeWire.includes("INF") || changeWire.includes("SUP")) {
        newValues = [...newValues, 136];
      }
    }

    if (keepThread) {
      if (keep.includes("INF") || keep.includes("SUP")) {
        newValues = [...newValues, 136];
      }
    }

    if (ciment) {
      if (cimentBand.includes("SUP")) {
        newValues = [...newValues, 31];
      } else if (cimentBand.includes("INF")) {
        newValues = [...newValues, 30];
      }
    }

    if (complement) {
      newValues = [...newValues, 136];
    }

    if (valueOthers.length > 0) {
      valueOthers.map(
        (item: { value: number }) => (newValues = [...newValues, item.value])
      );
    }

    if (
      patientObj.type === 2 &&
      patientObj.aname_id > 0 &&
      installMovable === true
    ) {
      if (infMovableProcedure === true && supMovableProcedure === false) {
        newValues = [...newValues, 127];
      }

      if (supMovableProcedure === true && infMovableProcedure === false) {
        newValues = [...newValues, 128];
      }

      if (supMovableProcedure && infMovableProcedure) {
        newValues = [...newValues, 492];
      }

      newValues = [...newValues, 492];
    }

    if (
      patientObj.type === 2 &&
      patientObj.aname_id > 0 &&
      moldageSecondMovable === true
    ) {
      if (infMovableProcedure === true && supMovableProcedure === false) {
        newValues = [...newValues, 144];
      }

      if (supMovableProcedure === true && infMovableProcedure === false) {
        newValues = [...newValues, 146];
      }

      if (supMovableProcedure && infMovableProcedure) {
        newValues = [...newValues, 493];
      }

      newValues = [...newValues, 493];
    }

    if (patientObj.type === 2 && braceMovel === true) {
      if (infMovable === true && supMovable === false) {
        newValues = [...newValues, 127];
      }

      if (supMovable === true && infMovable === false) {
        newValues = [...newValues, 128];
      }

      if (supMovable && infMovable) {
        newValues = [...newValues, 492];
      }

      newValues = [...newValues, 492];
    }

    if (patientObj.type === 2 && relizeMoldage === true) {
      if (infMovable === true && supMovable === false) {
        newValues = [...newValues, 144];
      }

      if (supMovable === true && infMovable === false) {
        newValues = [...newValues, 146];
      }

      if (supMovable && infMovable) {
        newValues = [...newValues, 493];
      }

      newValues = [...newValues, 493];
    }

    /*if (patientObj.aname_id > 0) {
      if (glueProcedures) {
        if (glueTubProcedures === "INF" || glueTubProcedures === "SUP") {
          newValues = [...newValues, 285];
        }
      }

      if (wireProcedures) {
        if (changeWireProcedures === "INF" || changeWireProcedures === "SUP") {
          newValues = [...newValues, 136];
        }
      }

      if (keepThreadProcedures) {
        if (keepProcedures === "INF" || keepProcedures === "SUP") {
          newValues = [...newValues, 136];
        }
      }

      if (cimentProcedures) {
        if (cimentBandProcedures === "SUP") {
          newValues = [...newValues, 2, 31];
        } else if (cimentBandProcedures === "INF") {
          newValues = [...newValues, 2, 30];
        }
      }
    }*/

    newValues.sort(
      (a: any, b: any) =>
        importanceOrder.indexOf(a) - importanceOrder.indexOf(b)
    );

    const mostImportantId: number | undefined = newValues[0];

    setMostImportantType(
      mostImportantId !== undefined ? typeMap[mostImportantId] : ""
    );

    setSelectedProceduresId(mostImportantId);

    const bandaIds: number[] = newValues.filter((id) => {
      const type = typeMap[id];
      return (
        type === "Banda Inferior" ||
        type === "Banda Superior" ||
        type === "Moldagem do Aparelho Complementar"
      );
    });

    if (bandaIds.length > 0) {
      setBandaExists(true);
      setBandaId(244);
    } else {
      setBandaExists(false);
      setBandaId(0);
    }

    if (patientObj.type === 2) {
      setBandaExists(false);
      setBandaId(0);
    }
  }, [
    aparate,
    aparateBrace,
    braceMovel,
    changeWire,
    ciment,
    cimentBand,
    complement,
    glue,
    glueTube,
    infMovable,
    infMovableProcedure,
    installMovable,
    keep,
    keepThread,
    moldageSecondMovable,
    patientObj.aname_id,
    patientObj.type,
    relizeMoldage,
    setBandaExists,
    setBandaId,
    setMostImportantType,
    setSelectedProceduresId,
    supMovable,
    supMovableProcedure,
    valueOthers,
    wire,
    controlContainment,
    highPlanning,
  ]);

  React.useEffect(() => {
    orderByImportance();
  }, [orderByImportance]);

  const getCurrentDate = () => {
    const date = new Date();
    const year = date.getFullYear();
    const month = String(date.getMonth() + 1).padStart(2, "0");
    const day = String(date.getDate()).padStart(2, "0");
    return `${year}-${month}-${day}`;
  };

  const currentDate = getCurrentDate();
  const callBestDate = React.useCallback(async () => {
    setLoading(true);
    try {
      const { data, status } = await getTimeTable({
        id: user.data.id,
        date: currentDate,
        interval: `${selectedTime ? selectedTime : 15}`,
        separator: 0,
        idProcedure: selectedProceduresId,
        idDent: patientObj.idDent_rel
          ? patientObj.idDent_rel
          : patientObj.idDent,
        idPac: patientObj.pac_id && patientObj.pac_id,
      });

      if (data?.data?.separetor) {
        setSeparatorId(data.data.separetor.idDent);
      }

      if ([200, 201].includes(status)) {
        setApiResponse(data.data);
        setBestTime(data.data.bestDay);
      } else {
        toast.error(data.message || "Erro ao buscar horários.");
      }
    } catch (error) {
      console.error("Erro ao buscar horários:", error);
      toast.error("Ocorreu um erro ao buscar horários. Tente novamente.");
    } finally {
      setLoading(false);
    }
  }, [
    user.data.id,
    currentDate,
    selectedTime,
    bandaExists,
    selectedProceduresId,
    patientObj.idDent_rel,
    patientObj.idDent,
    patientObj.pac_id,
    setSeparatorId,
    setBestTime,
  ]);

  const callBestDateBand = React.useCallback(async () => {
    try {
      setLoading(true);

      const dateStrBand: string = String(selectedDate);
      const dateBand: Date = new Date(dateStrBand);

      const optionsBand: Intl.DateTimeFormatOptions = {
        day: "2-digit",
        month: "2-digit",
        year: "numeric",
        timeZone: "America/Sao_Paulo",
      };

      const formattedDateBand: string = dateBand.toLocaleDateString(
        "pt-BR",
        optionsBand
      );

      const formattedDateUTCBand = () => {
        const date = formattedDateBand.split("/");
        return `${date[2]}-${date[1]}-${date[0]}`;
      };

      const { data, status } = await getTimeTable({
        id: user.data.id,
        date: formattedDateUTCBand(),
        interval: `${selectedTimeBand ? selectedTimeBand : 15}`,
        separator: 1,
        idProcedure: selectedProceduresId,
        idDent: patientObj.idDent_rel
          ? patientObj.idDent_rel
          : patientObj.idDent,
        idPac: patientObj.pac_id,
      });

      if ([200, 201].includes(status)) {
        setApiResponseBand(data.data);
        setBestTimeBand(data.data.bestDay);
      } else {
        toast.error(data?.message || "Erro ao buscar horários.");
      }
    } catch (error) {
      console.error("Erro ao buscar horários:", error);

      const errorMessage = "Ocorreu um erro inesperado ao buscar horários.";

      toast.error(errorMessage);
    } finally {
      setLoading(false);
    }
  }, [
    selectedDate,
    user.data.id,
    selectedTimeBand,
    selectedProceduresId,
    patientObj.idDent_rel,
    patientObj.idDent,
    patientObj.pac_id,
    setBestTimeBand,
  ]);

  React.useEffect(() => {
    callBestDate();

    if (bandaExists && selectedTimeBand) {
      callBestDateBand();
    }
  }, [selectedTimeBand, callBestDate, bandaExists, callBestDateBand]);

  const onNext = () => {
    if (!selectedDate) {
      toast.error("Selecione a data");
      return false;
    }

    if (!selectedTime) {
      toast.error("Selecione o tempo de consulta");
      return false;
    }

    if (!selectedHour) {
      toast.error("Selecione o horário da consulta");
      return false;
    }

    if (bandaExists) {
      if (!selectedDateBand) {
        toast.error("Selecione a data do Separador");
        return false;
      }

      if (!selectedTimeBand) {
        toast.error("Selecione o tempo de consulta do Separador");
        return false;
      }

      if (!selectedHourBand) {
        toast.error("Selecione o horário da consulta do Separador");
        return false;
      }
    }

    setStep(6);
  };

  function convertDateToAmerican(dateString: string): string {
    const year = dateString.slice(0, 4);
    const month = dateString.slice(4, 6);
    const day = dateString.slice(6, 8);
    return `${month}/${day}/${year}`;
  }

  function transformAvailableDates(data: ApiResponse): TransformedDate[] {
    const availableDates = data?.availableDates || {};
    const result: TransformedDate[] = [];

    // Itera sobre cada chave (data) em availableDates
    for (const date in availableDates) {
      if (availableDates.hasOwnProperty(date)) {
        // Converte a data para o padrão americano
        const americanDate = convertDateToAmerican(date);

        // Cria um objeto para cada data com suas horas
        const hours = availableDates[date];
        result.push({
          date: americanDate,
          hours: hours,
        });
      }
    }

    return result;
  }

  React.useEffect(() => {
    if (selectedDateBand && Object.keys(apiResponseBand).length > 0) {
      const transformedDates = transformAvailableDates(apiResponseBand);
      const formattedDate = selectedDateBand.format("MM/DD/YYYY");
      const matchingDateObj = transformedDates.find(
        (dateObj) => dateObj.date === formattedDate
      );
      if (matchingDateObj) {
        setHoursTimeBandState(
          matchingDateObj.hours.map((hour) =>
            dayjs(`2023-01-01 ${hour}`).format("HH:mm")
          )
        );
      } else {
        setHoursTimeBandState([]);
      }
    } else {
      setHoursTimeBandState([]);
    }
  }, [selectedDateBand, apiResponseBand]);

  // Crie o componente que será usado no slot "day"
  const CustomDay: React.FC<PickersDayProps<Dayjs>> = (props) => {
    const { day, ...other } = props;

    const isTargetDay = day.date() === patientObj.dia_vcto;

    return (
      <PickersDay
        {...other}
        day={day}
        sx={{
          ...(isTargetDay && {
            border: "2px solid red",
          }),
        }}
      />
    );
  };

  const MyDatePicker: React.FC<{
    apiResponse: ApiResponse;
    selectDatePicker: dayjs.Dayjs | null;
    handleDateChangePicker: (value: dayjs.Dayjs | null) => void;
    bestTime: string;
    onHoursChange?: (hours: string[]) => void;
  }> = ({
    apiResponse,
    handleDateChangePicker,
    selectDatePicker,
    bestTime,
    onHoursChange,
  }) => {
    const transformedDates = transformAvailableDates(apiResponse);

    // Cria um conjunto de datas disponíveis
    const availableDateSet = new Set<string>(
      transformedDates.map((dateObj: { date: any }) => dateObj.date) // Apenas as datas no formato MM/DD/YYYY
    );

    // Função para desabilitar datas que não estão disponíveis
    const shouldDisableDate = (date: Dayjs) => {
      const formattedDate = date.format("MM/DD/YYYY");
      return !availableDateSet.has(formattedDate); // Verifica se a data está no conjunto
    };

    // Função para obter as horas da data selecionada
    const getHoursForSelectedDate = (
      selectedDate: Dayjs | null
    ): string[] | null => {
      if (!selectedDate) return null;

      const formattedDate = selectedDate.format("MM/DD/YYYY");
      const matchingDateObj = transformedDates.find(
        (dateObj) => dateObj.date === formattedDate
      );

      if (matchingDateObj) {
        return matchingDateObj.hours.map((hour) =>
          dayjs(`2023-01-01 ${hour}`).format("HH:mm")
        );
      }

      return null;
    };

    // Função para lidar com a mudança de data
    const handleDateChange = (newValue: Dayjs | null) => {
      handleDateChangePicker(newValue);

      // Obter as horas da data selecionada usando o callback
      const hours = getHoursForSelectedDate(newValue);
      if (hours) {
        if (onHoursChange) onHoursChange(hours);
      } else {
        console.log("Nenhuma hora disponível para a data selecionada.");
      }
    };

    const bestTimeParsed = dayjs(bestTime, "YYYY-MM-DD");

    React.useEffect(() => {
      if (bestTimeParsed.isValid() && !selectDatePicker) {
        // Simula a seleção da data bestTimeParsed, formatando-a para DD/MM/YYYY

        handleDateChange(bestTimeParsed);
      }
      // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [bestTimeParsed, selectDatePicker, handleDateChangePicker]);

    return (
      <LocalizationProvider dateAdapter={AdapterDayjs} adapterLocale="pt-br">
        <DatePicker
          label="Selecione a data"
          value={selectDatePicker || bestTimeParsed}
          onChange={handleDateChange}
          format="DD/MM/YYYY"
          minDate={dayjs(new Date())}
          shouldDisableDate={shouldDisableDate}
          slots={{
            day: CustomDay,
            textField: (params) => (
              <TextField
                {...params}
                InputProps={{
                  ...params.InputProps,
                  readOnly: true, // Impede a digitação no campo
                }}
              />
            ),
          }}
        />
      </LocalizationProvider>
    );
  };

  /*React.useEffect(() => {
    if (bestTime && bestTime.bestDate && bestTime.bestDate.hours) {
      setSelectedHour(bestTime.bestDate.hours);
    }
  }, [bestTime, setSelectedHour]);*/

  const [isSelectHourAgain, setIsSelectHourAgain] =
    React.useState<boolean>(false);

  const transformedDates = transformAvailableDates(apiResponse);

  // Função para obter as horas da data selecionada
  const getHoursForSelectedDate = React.useCallback(
    (selectedDate: Dayjs | null): string[] | null => {
      if (!selectedDate) return null;

      const formattedDate = selectedDate.format("MM/DD/YYYY");
      const matchingDateObj = transformedDates.find(
        (dateObj) => dateObj.date === formattedDate
      );

      if (matchingDateObj) {
        return matchingDateObj.hours.map((hour) =>
          dayjs(`2023-01-01 ${hour}`).format("HH:mm")
        );
      }

      return null;
    },
    [transformedDates]
  );

  const handleGetHours = React.useCallback(
    (newValue: Dayjs | null) => {
      // Obter as horas da data selecionada usando o callback
      const hours = getHoursForSelectedDate(newValue);
      if (hours) {
        setHoursTime(hours);
      } else {
        console.log("Nenhuma hora disponível para a data selecionada.");
      }
    },
    [getHoursForSelectedDate, setHoursTime]
  );

  React.useEffect(() => {
    if (selectedTime && selectedDate && isSelectHourAgain) {
      handleGetHours(selectedDate);
    }
  }, [handleGetHours, isSelectHourAgain, selectedDate, selectedTime]);

  return (
    <>
      {loading ? (
        <CircularProgress />
      ) : (
        <Styled.Box>
          <>
            {bandaExists ? (
              <>
                <Typography variant="h5" sx={{ fontWeight: "bold" }}>
                  Agendamento - {mostImportantType}
                </Typography>
                <FormControl fullWidth margin="normal">
                  <InputLabel id="select-time-label">
                    Tempo da consulta
                  </InputLabel>
                  <Select
                    labelId="select-time-label"
                    value={selectedTime}
                    onChange={(e) => {
                      handleTimeChange(e);
                      setIsSelectHourAgain(true);
                      setTimeout(() => {
                        setIsSelectHourAgain(false);
                      }, 1000);
                    }}
                    label="Tempo da consulta"
                  >
                    <MenuItem value={10}>10 minutos</MenuItem>
                    <MenuItem value={15}>15 minutos</MenuItem>
                    <MenuItem value={20}>20 minutos</MenuItem>
                    <MenuItem value={30}>30 minutos</MenuItem>
                    <MenuItem value={45}>45 minutos</MenuItem>
                    <MenuItem value={60}>1 hora</MenuItem>
                  </Select>
                </FormControl>
                {selectedTime && (
                  <MyDatePicker
                    apiResponse={apiResponse}
                    handleDateChangePicker={handleDateChange}
                    selectDatePicker={selectedDate}
                    bestTime={bestTime}
                    onHoursChange={(hours) => setHoursTime(hours)}
                  />
                )}
                {selectedDate && selectedTime && (
                  <FormControl fullWidth margin="normal">
                    <InputLabel id="select-hour-label">
                      Horário disponível
                    </InputLabel>
                    <Select
                      labelId="select-hour-label"
                      value={selectedHour}
                      onChange={handleHourChange}
                      label="Horário disponível"
                    >
                      {/*bestTime &&
                      bestTime.bestDate &&
                      bestTime.bestDate.hours && (
                        <MenuItem key="best" value={bestTime.bestDate.hours}>
                          {bestTime.bestDate.hours} (Recomendado)
                        </MenuItem>
                      )*/}
                      {hoursTime &&
                        hoursTime.map((hour) => (
                          <MenuItem key={hour} value={hour}>
                            {hour}
                          </MenuItem>
                        ))}
                    </Select>
                  </FormControl>
                )}

                {selectedHour && (
                  <Styled.BoxDescription>
                    <Typography sx={{ fontWeight: "bold !important" }}>
                      Procedimento
                    </Typography>

                    <Typography>{mostImportantType}</Typography>
                  </Styled.BoxDescription>
                )}
                {selectedHour && (
                  <>
                    <Divider />
                    <Typography variant="h5" sx={{ fontWeight: "bold" }}>
                      Agendamento - Separador
                    </Typography>

                    <FormControl fullWidth margin="normal">
                      <InputLabel id="select-time-label">
                        Tempo da consulta
                      </InputLabel>
                      <Select
                        labelId="select-time-label"
                        value={selectedTimeBand}
                        onChange={handleTimeChangeBand}
                        label="Tempo da consulta"
                      >
                        <MenuItem value={10}>10 minutos</MenuItem>
                        <MenuItem value={15}>15 minutos</MenuItem>
                        <MenuItem value={20}>20 minutos</MenuItem>
                        <MenuItem value={30}>30 minutos</MenuItem>
                        <MenuItem value={45}>45 minutos</MenuItem>
                        <MenuItem value={60}>1 hora</MenuItem>
                      </Select>
                    </FormControl>

                    {selectedTimeBand && (
                      <MyDatePicker
                        apiResponse={apiResponseBand}
                        handleDateChangePicker={handleDateChangeBand}
                        selectDatePicker={selectedDateBand}
                        bestTime={bestTimeBand}
                        onHoursChange={(hours) => setHoursTimeBandState(hours)}
                      />
                    )}
                    {selectedTimeBand && (
                      <FormControl fullWidth margin="normal">
                        <InputLabel id="select-hour-label">
                          Horário disponível
                        </InputLabel>
                        <Select
                          labelId="select-hour-label"
                          value={selectedHourBand}
                          onChange={handleHourChangeBand}
                          label="Horário disponível"
                        >
                          {/*bestTime &&
                            bestTime.bestDate &&
                            bestTime.bestDate.hours && (
                              <MenuItem
                                key="best"
                                value={bestTime.bestDate.hours}
                              >
                                {bestTime.bestDate.hours} (Recomendado)
                              </MenuItem>
                            )*/}
                          {hoursTimeBandState &&
                            hoursTimeBandState.map((hour) => (
                              <MenuItem key={hour} value={hour}>
                                {hour}
                              </MenuItem>
                            ))}
                        </Select>
                      </FormControl>
                    )}

                    {selectedHourBand && (
                      <Styled.BoxDescription>
                        <Typography sx={{ fontWeight: "bold !important" }}>
                          Procedimento
                        </Typography>

                        <Typography>Separador</Typography>
                      </Styled.BoxDescription>
                    )}
                  </>
                )}
              </>
            ) : (
              <>
                <Typography variant="h5" sx={{ fontWeight: "bold" }}>
                  Agendamento - {mostImportantType}
                </Typography>
                <FormControl fullWidth margin="normal">
                  <InputLabel id="select-time-label">
                    Tempo da consulta
                  </InputLabel>
                  <Select
                    labelId="select-time-label"
                    value={selectedTime}
                    onChange={(e) => {
                      handleTimeChange(e);
                      setIsSelectHourAgain(true);
                      setTimeout(() => {
                        setIsSelectHourAgain(false);
                      }, 1000);
                    }}
                    label="Tempo da consulta"
                  >
                    <MenuItem value={10}>10 minutos</MenuItem>
                    <MenuItem value={15}>15 minutos</MenuItem>
                    <MenuItem value={20}>20 minutos</MenuItem>
                    <MenuItem value={30}>30 minutos</MenuItem>
                    <MenuItem value={45}>45 minutos</MenuItem>
                    <MenuItem value={60}>1 hora</MenuItem>
                  </Select>
                </FormControl>
                {selectedTime && (
                  <MyDatePicker
                    apiResponse={apiResponse}
                    handleDateChangePicker={handleDateChange}
                    selectDatePicker={selectedDate}
                    bestTime={bestTime}
                    onHoursChange={(hours) => setHoursTime(hours)}
                  />
                )}
                {selectedDate && selectedTime && (
                  <FormControl fullWidth margin="normal">
                    <InputLabel id="select-hour-label">
                      Horário disponível
                    </InputLabel>
                    <Select
                      labelId="select-hour-label"
                      value={selectedHour}
                      onChange={handleHourChange}
                      label="Horário disponível"
                    >
                      {/*bestTime &&
                      bestTime.bestDate &&
                      bestTime.bestDate.hours && (
                        <MenuItem key="best" value={bestTime.bestDate.hours}>
                          {bestTime.bestDate.hours} (Recomendado)
                        </MenuItem>
                      )*/}
                      {hoursTime &&
                        hoursTime.map((hour) => (
                          <MenuItem key={hour} value={hour}>
                            {hour}
                          </MenuItem>
                        ))}
                    </Select>
                  </FormControl>
                )}

                {selectedHour && (
                  <Styled.BoxDescription>
                    <Typography sx={{ fontWeight: "bold !important" }}>
                      Procedimento
                    </Typography>

                    <Typography>{mostImportantType}</Typography>
                  </Styled.BoxDescription>
                )}
              </>
            )}
          </>

          {selectedHour ? (
            <>
              <Styled.BtnFixed>
                <Button fullWidth onClick={() => setStep(4)} variant="outlined">
                  Voltar
                </Button>
                <Button fullWidth onClick={onNext}>
                  Continuar
                </Button>
              </Styled.BtnFixed>
            </>
          ) : (
            <Styled.BtnFixedAnam>
              <Button fullWidth onClick={() => setStep(4)} variant="outlined">
                Voltar
              </Button>
            </Styled.BtnFixedAnam>
          )}
        </Styled.Box>
      )}
    </>
  );
};

export { Schedule };
